<template>
  <LazyHomeCommonLayout>
    <template #content>
      <main class="subPage contactPage">
        <div class="backBg"></div>
        <LazyHomeSubPagesSupportContactUsInfo v-fade />
        <LazyHomeContentCP v-fade class="sub" />
      </main>
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {
  LazyHomeContentCP,
  LazyHomeSubPagesSupportContactUsInfo
} from "#components";

useHead({
  title: 'Contact Codepresso: We\'re Here to Assist',
  meta: [
    {
      name: 'description',
      content: "Reach out to us for any queries, support, or sales inquiries. Choose the right category, and our dedicated teams will promptly assist you."
    },
    {
      name: 'title',
      content: 'Contact Codepresso: We\'re Here to Assist'
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ]
})
</script>

<style>
/* 이 페이지 마크업의 레이아웃 규칙(.container_main 의 좌우 여백·최대 폭 등)은 main_style.scss
   (→ _main.scss)에만 있다. 이 페이지는 그 파일을 싣지 않고 다른 페이지(예전 홈, 요금제)가 전역으로
   실어 둔 것에 기대고 있어, 그 페이지를 거쳐 들어올 때만 맞고 새로고침·직접 진입하면 내용이 좌우
   끝까지 붙었다(REQ-408). renewal 홈(#2196)은 이 파일을 싣지 않아 홈을 거쳐도 깨진다.
   요금제 페이지처럼 이 페이지가 직접 싣는다. */
@import "~/assets/scss/main_style.scss";

/* main_style.scss 를 실으면 _main.scss 의 페이드 게이트(`.sectionLayout { opacity: 0 }` — v-fade 가 `.fade_up` 을
   붙여야 보인다)도 따라온다. 직접 진입하면 예전에는 이 규칙이 없어 폼이 HTML 그대로 바로 보였다. 게이트가 걸리면
   hydration 전까지 폼 자리가 비고, 폼이 화면 높이의 5배를 넘으면(가로 모드 폰의 기업 도입 문의 폼) v-fade 의
   조건(요소가 20% 이상 보일 때)에 닿지 못해 끝내 보이지 않는다. 이 페이지에서는 게이트를 끈다. */
.contactPage .sectionLayout {
  opacity: 1;
}
</style>
